module.exports = __webpack_public_path__ + "img/screen.3dd29b58.svg";